module.exports = __webpack_public_path__ + "static/media/image-1.c1b28a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Algorithms/image-1.png
// module id = 246
// module chunks = 0